/* eslint-disable react/no-did-update-set-state */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { CHECKOUT_URL } from 'Route/Checkout/Checkout.config';
import {
    CHECKOUT_ACCOUNT, CUSTOMER_ACCOUNT,
    CUSTOMER_SUB_ACCOUNT
} from 'SourceComponent/Header/Header.config';
import { HeaderContainer as SourceHeaderContainer, mapDispatchToProps } from 'SourceComponent/Header/Header.container';
import { TOP_NAVIGATION_TYPE } from 'Store/Navigation/Navigation.reducer';
import history from 'Util/History';

/** @namespace Pwa/Component/Header/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    navigationState: state.NavigationReducer[TOP_NAVIGATION_TYPE].navigationState,
    cartTotals: state.CartReducer.cartTotals,
    header_logo_src: state.ConfigReducer.header_logo_src,
    isOffline: state.OfflineReducer.isOffline,
    isSignedIn: state.MyAccountReducer.isSignedIn,
    logo_alt: state.ConfigReducer.logo_alt,
    logo_height: state.ConfigReducer.logo_height,
    logo_width: state.ConfigReducer.logo_width,
    isLoading: state.ConfigReducer.isLoading,
    device: state.ConfigReducer.device,
    activeOverlay: state.OverlayReducer.activeOverlay,
    isWishlistLoading: state.WishlistReducer.isLoading,
    defaultCustomerCurrency: state.MyAccountReducer.customer.currency,
    current_currency_code: state.ConfigReducer.currencyData?.current_currency_code,
    currencyData: state.ConfigReducer.currencyData,
    activeOfferId: state.OfferReducer.activeOfferId,
    offerItemsCount: state.OfferReducer.itemsCount
});

/** @namespace Pwa/Component/Header/Container */
export class HeaderContainer extends SourceHeaderContainer {
    containerProps() {
        const {
            activeOverlay,
            navigationState,
            cartTotals,
            header_logo_src,
            logo_alt,
            logo_height,
            logo_width,
            isLoading,
            isSignedIn,
            device,
            isWishlistLoading,
            defaultCustomerCurrency,
            current_currency_code,
            currencyData,
            activeOfferId,
            offerItemsCount
        } = this.props;

        const {
            isClearEnabled,
            searchCriteria,
            showMyAccountLogin,
            shouldRenderCartOverlay
        } = this.state;

        const {
            location: {
                pathname
            }
        } = history;

        const isCheckout = pathname.includes(CHECKOUT_URL);

        return {
            activeOverlay,
            navigationState,
            cartTotals,
            header_logo_src,
            logo_alt,
            logo_height,
            logo_width,
            isLoading,
            isSignedIn,
            isClearEnabled,
            searchCriteria,
            isCheckout,
            showMyAccountLogin,
            device,
            isWishlistLoading,
            shouldRenderCartOverlay,
            defaultCustomerCurrency,
            current_currency_code,
            firstname: this.getUserName(),
            currencyData,
            activeOfferId,
            offerItemsCount
        };
    }

    onMyAccountOutsideClick() {
        const {
            goToPreviousNavigationState,
            hideActiveOverlay,
            navigationState: { name },
            device
        } = this.props;

        if (device.isMobile || ![CUSTOMER_ACCOUNT, CUSTOMER_SUB_ACCOUNT, CHECKOUT_ACCOUNT].includes(name)) {
            return;
        }

        if (name === CUSTOMER_SUB_ACCOUNT) {
            goToPreviousNavigationState();
        }

        this.goToDefaultHeaderState();
        hideActiveOverlay();
        this.setState({ showMyAccountLogin: false });
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeaderContainer));
